import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import {
  createServiceWorkerUpdateHandler,
  startServiceWorkerUpdatePolling,
} from "./serviceWorkerUpdate";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <App />
);

const serviceWorkerUpdateHandler = createServiceWorkerUpdateHandler({
  buildVersion: process.env.REACT_APP_BUILD_VERSION,
});
let stopUpdatePolling: (() => void) | undefined;

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener(
    "controllerchange",
    serviceWorkerUpdateHandler.onControllerChange
  );
}

serviceWorkerRegistration.register({
  onRegistered: (registration) => {
    stopUpdatePolling?.();
    stopUpdatePolling = startServiceWorkerUpdatePolling(registration);
  },
  onUpdate: serviceWorkerUpdateHandler.onUpdate,
});

window.addEventListener("pagehide", () => {
  stopUpdatePolling?.();
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.removeEventListener(
      "controllerchange",
      serviceWorkerUpdateHandler.onControllerChange
    );
  }
}, { once: true });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
